export function isNormalVersionTag(version?: string | null): version is string {
    if (!version) {
        return false;
    }
    const versionRegex = /^v\d+\.\d+\.\d+(-\d+-[a-f0-9]+)?$/;
    return versionRegex.test(version);
}
